<template>
    <div v-loading="dataLoading">        
		<div class="group">
			<div class="page-group-title"><span>基本信息</span></div>			
			<el-card shadow="never">
				<div class="disBetween">
					<el-row style="min-width: 20%;" v-if="data && data.avatar">
						<el-col :xs="24" :sm="12" :md="8">
							<span class="color-info">用户头像: </span>							
							<el-image :src="data.avatar | coverImage(100,100)" fit="cover" :preview-src-list="[data.avatar]"
							    style="width:80px;height:80px;"></el-image>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户ID: </span>{{data.id}}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户名称: </span>{{data.name}}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">手机号: </span><span v-if="data.telephone">{{ ` ${data.areaCode && data.areaCode.split('_')[0]} ${data.telephone}`}}</span></el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">个性签名: </span>{{ data.signature }}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">注册时间: </span>{{ data.registTime }}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">来源渠道: </span>{{ data.source && sourceMap.get(data.source) }}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">注册终端: </span>{{ data.terminal && terminalMap.get(data.terminal) }}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">最近登录时间: </span>{{ data.lastLoginTime }}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">最近登录城市: </span>{{ data.lastLoginCityName }}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">实名信息: </span>
							<span v-if="data.authority == 0"><el-link  @click="toRealnameManage(data.id)" class="color-blue">暂无</el-link></span>
					        <template v-else>
					            <span v-if="$utils.have('/commonPerformer/search')"><el-link  @click="toRealnameManage(data.id)" class="color-blue">点击查看</el-link></span>
					            <span v-else>无权限管理</span>                            
					        </template></el-col>
					</el-row>
				</div>				
			 </el-card>
			 <div class="page-group-title MT20"><span>消费记录</span></div>
			 <el-card shadow="never">
			     <el-row :gutter="40">
			        <el-col :span="6" v-if="data && data.orderSta">
						 <span class="color-info">演出订单: </span>
						 <template v-if="data.orderSta.activityOrderNum > 0">
							<el-link :href="`/activityManage/order/list?searchType2=5&searchValue2=${data.id}`" class="color-blue">{{data.orderSta.activityOrderNum}}</el-link>
						 </template>
						 <template v-else>
							 {{data.orderSta.activityOrderNum}}
						 </template>
						 
					</el-col>
			        <el-col :span="6" v-if="data && data.orderSta">
						 <span class="color-info">周边订单: </span>
						 <template v-if="data.orderSta.goodsOrderNum > 0">
							<el-link :href="`/goodsManage/order/list?searchType=5&searchValue=${data.id}`" class="color-blue">{{data.orderSta.goodsOrderNum}}</el-link>
						 </template>
						 <template v-else>
							{{data.orderSta.goodsOrderNum}}
						 </template>
					</el-col>
			         <el-col :span="6" v-if="data && data.orderSta">
						 <span class="color-info">众筹订单: </span>
						 <template v-if="data.orderSta.raiseOrderNum > 0">
							<el-link :href="`/raise/order/list?searchType=5&searchValue=${data.id}`" class="color-blue">{{data.orderSta.raiseOrderNum}}</el-link>
						 </template>
						 <template v-else>
						 	{{data.orderSta.raiseOrderNum}}
						 </template>
					</el-col>
			        <el-col :span="6" v-if="data && data.orderSta">
						 <span class="color-info">酒店订单: </span>
						  <template v-if="data.orderSta.hotelOrderNum > 0">
							<el-link :href="`/hotel/order?querySnType=5&querySn=${data.id}`" class="color-blue">{{data.orderSta.hotelOrderNum}}</el-link>
						 </template>
						 <template v-else>
						 	{{data.orderSta.hotelOrderNum}}
						 </template>
				    </el-col>
			     </el-row>
			  </el-card>
			  <div class="page-group-title MT20"><span>用户画像-基础属性</span></div>
			  <el-card shadow="never">
			      <el-row :gutter="40">
			        <el-col :span="6" v-if="data && data.portraitInfo">						
						<el-popover
						    placement="bottom"
						    width="400"
						    trigger="click"
						    :content="data.portraitInfo.sexLogic">
						    <span class="color-info" slot="reference">身份证性别：<span>{{data.portraitInfo.sexView}}</span></span>
						</el-popover>
					</el-col>
			        <el-col :span="6" v-if="data && data.portraitInfo">
						<el-popover
						  placement="bottom"
						  width="400"
						  trigger="click"
						  :content="data.portraitInfo.constellationLogic">
						  <span class="color-info" slot="reference">星座：<span>{{data.portraitInfo.constellationView}}</span></span>
						</el-popover>
					</el-col>
			        <el-col :span="6" v-if="data && data.portraitInfo">						  
						  <el-popover
						    placement="bottom"
						    width="400"
						    trigger="click"
						    :content="data.portraitInfo.certAgeGroupLogic">
						    <span class="color-info" slot="reference">年龄段：<span>{{data.portraitInfo.certAgeGroupView}}</span></span>
						  </el-popover>
					</el-col>
			        <el-col :span="6" v-if="data && data.portraitInfo">						  
						  <el-popover
						      placement="bottom"
						      width="400"
						      trigger="click"
						      :content="data.portraitInfo.chineseZodiacLogic">
						      <span class="color-info" slot="reference">生肖：<span>{{data.portraitInfo.chineseZodiacView}}</span></span>
						  </el-popover>
					</el-col>
			      </el-row>
			   </el-card>
			   <div class="page-group-title MT20"><span>用户画像-地理位置</span></div>
			   <el-card shadow="never">
			       <el-row :gutter="40">
			           <el-col :span="6" v-if="data && data.portraitInfo">						   				   
						   <el-popover
						       placement="bottom"
						       width="400"
						       trigger="click"
						       :content="data.portraitInfo.certProvinceLogic">
						       <span class="color-info" slot="reference">出生省份：<span>{{data.portraitInfo.certProvinceView}}</span></span>
						   </el-popover>
					   </el-col>
			           <el-col :span="6" v-if="data && data.portraitInfo">						   
						   <el-popover
						       placement="bottom"
						       width="400"
						       trigger="click"
						       :content="data.portraitInfo.certCityLogic">
						       <span class="color-info" slot="reference">出生城市：<span>{{data.portraitInfo.certCityView}}</span></span>
						   </el-popover>
						</el-col>
			           <el-col :span="6" v-if="data && data.portraitInfo">						   
						   <el-popover
						       placement="bottom"
						       width="400"
						       trigger="click"
						       :content="data.portraitInfo.latestProvinceLogic">
						       <span class="color-info" slot="reference">最近所在省份：<span>{{data.portraitInfo.latestProvinceView}}</span></span>
						   </el-popover>
						</el-col>
			           <el-col :span="6" v-if="data && data.portraitInfo">						   
						   <el-popover
						       placement="bottom"
						       width="400"
						       trigger="click"
						       :content="data.portraitInfo.latestCityLogic">
						       <span class="color-info" slot="reference">最近所在城市：<span>{{data.portraitInfo.latestCityView}}</span></span>
						   </el-popover>
						</el-col>
			       </el-row>
			    </el-card>
				<div class="page-group-title MT20"><span>用户画像-行为习惯</span></div>
				<el-card shadow="never">
				    <el-row :gutter="40">
				        <el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.useAppleLogic">
							    <span class="color-info" slot="reference">使用苹果设备：<span>{{data.portraitInfo.useAppleView}}</span></span>
							</el-popover>
						</el-col>
				        <el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.useAndroidLogic">
							    <span class="color-info" slot="reference">使用安卓设备：<span>{{data.portraitInfo.useAndroidView}}</span></span>
							</el-popover>
						</el-col>
				        <el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.activeTimePeriodLogic">
							    <span class="color-info" slot="reference">活跃时间段：<span>{{data.portraitInfo.activeTimePeriodView}}</span></span>
							</el-popover>
						</el-col>
				        <el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.useCouponLogic">
							    <span class="color-info" slot="reference">优惠券使用意愿：<span>{{data.portraitInfo.useCouponView}}</span></span>
							</el-popover>
						</el-col>
						<el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.refundNumLogic">
							    <span class="color-info" slot="reference">退单次数：<span>{{data.portraitInfo.refundNum}}</span></span>
							</el-popover>
						</el-col>
						<el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.clickBannerLogic">
							    <span class="color-info" slot="reference">是否喜欢点击：<span>{{data.portraitInfo.clickBannerView}}</span></span>
							</el-popover>
						</el-col>
						<el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.silenceLogic">
							    <span class="color-info" slot="reference">是否沉默：<span>{{data.portraitInfo.silenceView}}</span></span>
							</el-popover>
						</el-col>						
						<el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.preMonthActiveLogic">
							    <span class="color-info" slot="reference">上月活跃度：<span>{{data.portraitInfo.preMonthActiveView}}</span></span>
							</el-popover>
						</el-col>
						<el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.joinShareEventLogic">
							    <span class="color-info" slot="reference">分享活动参与度：<span>{{data.portraitInfo.joinShareEventView}}</span></span>
							</el-popover>
						</el-col>
						<el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.joinExpandEventLogic">
							    <span class="color-info" slot="reference">膨胀红包参与度：<span>{{data.portraitInfo.joinExpandEventView}}</span></span>
							</el-popover>
						</el-col>
						<el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.shareChannelLogic">
							    <span class="color-info" slot="reference">分享渠道偏好：<span>{{data.portraitInfo.shareChannelView}}</span></span>
							</el-popover>
						</el-col>
						<el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.usePayPlatformLogic">
							    <span class="color-info" slot="reference">支付渠道偏好：<span>{{data.portraitInfo.usePayPlatformView}}</span></span>
							</el-popover>
						</el-col>						
				    </el-row>
				 </el-card>
				 <div class="page-group-title MT20"><span>用户画像-资信能力</span></div>
				 <el-card shadow="never">
				     <el-row :gutter="40">
				        <el-col :span="6" v-if="data && data.portraitInfo">
							 <el-popover
							     placement="bottom"
							     width="400"
							     trigger="click"
							     :content="data.portraitInfo.rfmLogic">
							     <span class="color-info" slot="reference">RFM：<span>{{data.portraitInfo.rfmView}}</span></span>
							 </el-popover>
						</el-col>
				        <el-col :span="6" v-if="data && data.portraitInfo">
							<el-popover
							    placement="bottom"
							    width="400"
							    trigger="click"
							    :content="data.portraitInfo.userLevelLogic">
							    <span class="color-info" slot="reference">用户级别：<span>{{data.portraitInfo.userLevel}}</span></span>
							</el-popover>
						</el-col>
				     </el-row>
				  </el-card>
				  <div class="page-group-title MT20" v-if="showMusicChart || showActivityChart"><span>用户画像-兴趣偏好</span></div>
				  <el-card shadow="never" v-if="showMusicChart || showActivityChart">
				      <el-row :gutter="40">
				          <el-col :span="8" v-if="data && data.portraitInfo && showMusicChart" >
							  <span class="color-info">购买演出音乐风格偏好: </span>
							  <el-link @click="$refs.musicChart.show(data)" class="color-blue">点击查看</el-link>							 
							</el-col>
				          <el-col :span="8" v-if="data && data.portraitInfo && showActivityChart">
							  <span class="color-info">购买活动类型偏好: </span>
							  <el-link  @click="$refs.activityChart.show(data)"  class="color-blue">点击查看</el-link>							 
						   </el-col>
				      </el-row>
				   </el-card>
		</div>		
		<div class="group MT20">
		    <el-button  v-if="$utils.have('/userPunish/search')" type="danger" @click="toPunish">处罚</el-button>
		    <el-button @click="goBack()">返回</el-button>
		</div>
		<MusicChart ref="musicChart" @onUpdate="getInfo" :data="data"></MusicChart>
		<ActivityChart ref="activityChart" @onUpdate="getInfo" :data="data"></ActivityChart>
	</div>
</template>

<script>
import MusicChart from './components/musicChart';
import ActivityChart from './components/activityChart';
import {dataMap} from './components/mixins';

export default {
	mixins: [dataMap],
    props: {
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    components:{MusicChart,ActivityChart},
    data() {
        return {
            dataLoading: false,
            btnLoading:false,
            showMusicChart:false,
			showActivityChart:false,
            redirect: this.$route.query.redirect || "/user/fans/list",
            data:{},
			
        };
    },
    created(){
        if (this.id) {
            this.getInfo();
        }
    },
    methods: {
        //获取详情
        getInfo(){
            this.pageLoading = true;
            this.$request({
                url: '/fans/manger/detail',
                method: "POST",
                data: {id:this.id}
            }).then(res=>{
                const {state, msg, result} = res.data;
                if (state == 1) {
                    this.data = result
					//portraitInfo.musicStyleSta  portraitInfo.activityTypeSta
					this.data.portraitInfo.musicStyleSta.forEach( item => {
						
					    if( item.value >= 1 ){
					        this.showMusicChart = true
					    }
					})
					this.data.portraitInfo.activityTypeSta.forEach( item => {
					    if( item.value >= 1 ){
					        this.showActivityChart = true
					    }
					})
                } else {
                    this.$message.error(msg || "请求失败");
                }
            }).catch(() => {
                this.$message.error("请求错误");
            }).finally(()=>{
                this.pageLoading = false;
            })
        },
       toRealnameManage(id){
           this.$router.push({path: '/user/realName/list', query: {id}})
       },
       toPunish(){
           this.$router.push({path: '/user/punish/list', query: {id: this.id}})
       },
	   toActivityOrder(id){
		 this.$router.push({path: '/activityManage/order/list', query: {id}})  
	   },
		//返回
        goBack() {
            this.$router.push({
                path: this.redirect,
            });
        } 
    },
};
</script>
<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 28px;
    }
}
.disBetween{
	display: flex;
	justify-content: space-between;
	
}
::v-deep .page-group-title{
	margin-top: 20px;
}
::v-deep .color-blue{
	cursor: pointer;
	color:#409EFF
}
.color-info{
	cursor: pointer;
	span{
		color:#000
	}
}
.color-info:hover{
	color:#409EFF
}
</style>

